<div class="wrap">
    <h3>Modifier votre fond d'écran</h3>
    <form [formGroup]="updateBackgroundForm">
        <ng-container>
            <div class="label-file">
                <p> Choisir une image </p>
                <input matinput type="file" class="input-file" formControlName="imgFile"
                    (change)="convertFile($event, 'imgLink')">
            </div>
        </ng-container>

        <!-- <mat-form-field appearance="outline">
            <mat-label>Lien de l'image</mat-label>
            <input matInput formControlName='imgLink'
                (input)="convertFile(updateBackgroundForm.get('imgLink').value , 'imgFile')">
        </mat-form-field> -->

        <ng-container>
            <img [src]="imageBase64 " *ngIf="imageBase64">
        </ng-container>

        <div class="btn_action">
            <button type="button" class="back" (click)="dialogRef.close()">Annuler</button>
            <button type="button" class="confirm" [mat-dialog-close]="this.imageBase64">Confirmer</button>
        </div>
    </form>
</div>